import * as React from 'react';
import { BadgeCore, } from '@core-front/badge';
import Icon from '@telia-front/icon';
const Badge = (props) => {
    const { className, purpose } = props;
    const BEM = () => {
        const classArray = [];
        switch (purpose) {
            case 'attention':
            case 'error':
            case 'information':
            case 'employee':
            case 'employee-active':
                classArray.push(`badge--${purpose}`);
        }
        if (props.className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getPurpose = () => {
        switch (purpose) {
            case 'attention':
            case 'error':
            case 'information':
            case 'employee':
            case 'employee-active':
                return undefined;
            default:
                return purpose;
        }
    };
    return (React.createElement(BadgeCore, Object.assign({}, props, { className: BEM(), purpose: getPurpose(), components: {
            Icon,
        } })));
};
export { Badge as default, };
